import PopupNew from './popup-new';

const MEDIA_CARD_CLASS = 'media-card';

export const getPopupData = (parent = document) =>
  Array.from(parent.querySelectorAll(`.${MEDIA_CARD_CLASS}--image, .${MEDIA_CARD_CLASS}--video`))
    .filter((item) => !item.className.includes('template'))
    .map((card, index) => {
      return {
        clickItem: card,
        image: card.querySelector(`.${MEDIA_CARD_CLASS}__image`).getAttribute('src'),
        video: card.querySelector(`.${MEDIA_CARD_CLASS}__image`).dataset.videoSrc || null,
        src: card.querySelector(`.${MEDIA_CARD_CLASS}__image`).dataset.srcUrl || null,
        type: card.classList.contains(`${MEDIA_CARD_CLASS}--video`)
          ? PopupNew.TYPES.VIDEO
          : PopupNew.TYPES.IMAGE,
        title: card.querySelector(`.${MEDIA_CARD_CLASS}__info-title`)?.textContent,
        text: card.querySelector(`.${MEDIA_CARD_CLASS}__info-date`)?.textContent,
        relative: card.querySelector(`.${MEDIA_CARD_CLASS}__relative`)?.dataset.relative || null,
        index: index
      };
    });

let popup = null;

const MediaComponent = () => {
  if (
    document.querySelector(`.${PopupNew.CLASSES.POPUP}`) &&
    document.querySelector(`.${MEDIA_CARD_CLASS}`)
  ) {
    popup = new PopupNew(getPopupData());
  }
};

export const getPopupInstance = () => popup;

export const Media = () => {
  $(document).ready(() => MediaComponent());
};
